import { Expose } from 'class-transformer';
import { decorate } from 'ts-mixer';

export class Response<T> {
    @decorate(Expose({ name: 'result_code' }))
    resultCode: number = 0;
    @decorate(Expose({ name: 'message' }))
    message: string = '';
    @decorate(Expose({ name: 'result' }))
    result!: T;
}
